.gj{border:1px solid #ddd;}